import { useSelector } from 'react-redux'

import { useGetUserQuery } from 'common'
import { useHomeTabs } from 'hooks/home/tabs'
import {
  teamsSelector,
  titleSelector,
  userGroupsWhereAdminSelector,
  usersSelector,
} from 'selectors/home_bar'

const ALL_SCOPE_TYPES = new Set(['all_users', 'all_teams', 'page', 'all_users_and_teams'])

const findInList = (list, scopeId) => (
  list?.find((item) => String(item.id) === String(scopeId))
)

/**
 * Resolves the avatar shown in the scope dropdown control (matches list item icons).
 * Falls back to the scope title initial when redux list data is not loaded yet.
 */
export const useScopeControlAvatar = () => {
  const { getTabScopeV1 } = useHomeTabs()
  const { type, id } = getTabScopeV1()
  const title = useSelector(titleSelector)
  const users = useSelector(usersSelector)
  const teams = useSelector(teamsSelector)
  const userGroups = useSelector(userGroupsWhereAdminSelector)
  const { data: currentUser } = useGetUserQuery()

  if (type === 'my_calendly') {
    return {
      letter: currentUser?.avatar_letter ?? title?.[0]?.toUpperCase(),
      src: currentUser?.avatar_url ?? null,
    }
  }

  if (ALL_SCOPE_TYPES.has(type)) {
    return { letter: ' ', src: null }
  }

  let match
  if (type === 'user_single') {
    match = findInList(users, id)
  } else if (type === 'page_single') {
    match = findInList(teams, id)
  } else if (type === 'user_group') {
    match = findInList(userGroups, id)
  }

  if (match) {
    return {
      letter: match.avatar_letter ?? match.name?.[0]?.toUpperCase(),
      src: match.avatar_url ?? null,
    }
  }

  return {
    letter: title?.[0]?.toUpperCase(),
    src: null,
  }
}
